'use strict';
import {combineReducers} from 'redux';
import {USER_TODO_LIST_NAME} from '../redux/state';
import {userTodoListReduxList} from '../redux/userTodoList';


export * from './state';

export const todoMessages = combineReducers({
  [USER_TODO_LIST_NAME]: userTodoListReduxList.reducers.reducer,
});



// WEBPACK FOOTER //
// ./src/js/todo-messages/reducers/index.js